<template>
  <div class="demand-list-wrapper">
    <a-card :bordered="false" class="content">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">
          <span class="title-text">技术服务</span>
          <span class="title-bg">TECHN SERVICE</span>
        </h1>
      </div>

      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="search-row">
          <span class="search-label">搜索:</span>
          <a-input
            class="search-input"
            placeholder="请输入搜索关键字"
            v-model="queryParam.name"
            @keyup.enter.native="searchQuery"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button type="primary" icon="search" @click="searchQuery" class="search-btn">
          </a-button>
        </div>
        <div class="search-row">
          <span class="search-label">需求单位:</span>
          <a-input
            class="search-input"
            placeholder="请输入需求单位"
            v-model="queryParam.requirementUnit"
            @keyup.enter.native="searchQuery"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button type="primary" icon="search" @click="searchQuery" class="search-btn">
          </a-button>
        </div>
      </div>

      <!-- 筛选区域 -->
      <div class="filter-section">
        <div class="filter-row">
          <span class="filter-label">所属领域:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.technicalField }"
              @click="handleFilterChange('technicalField', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in fieldOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.technicalField === item.value }"
              @click="handleFilterChange('technicalField', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div>
        <!-- <div class="filter-row">
          <span class="filter-label">按合作方式:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.cooperateWay }"
              @click="handleFilterChange('cooperateWay', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in cooperateOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.cooperateWay === item.value }"
              @click="handleFilterChange('cooperateWay', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div> -->
        <div class="filter-row">
          <span class="filter-label">所在地区:</span>
          <div class="filter-tags">
            <a-tag
              :class="{ 'tag-active': !queryParam.areaId }"
              @click="handleFilterChange('areaId', '')"
              class="filter-tag"
            >
              全部
            </a-tag>
            <a-tag
              v-for="item in regionOptions"
              :key="item.value"
              :class="{ 'tag-active': queryParam.areaId === item.value }"
              @click="handleFilterChange('areaId', item.value)"
              class="filter-tag"
            >
              {{ item.text }}
            </a-tag>
          </div>
        </div>
      </div>

      <!-- 结果统计和排序 -->
      <div class="result-header">
        <div class="result-count">
          共找到<span class="count-number">{{ ipagination.total || 0 }}</span>项需求
        </div>
        <div class="sort-options">
          <span
            :class="['sort-item', { 'sort-active': sortType === 'latest' }]"
            @click="handleSortChange('latest')"
          >
            最新发布排序
          </span>
          <span
            :class="['sort-item', { 'sort-active': sortType === 'views' }]"
            @click="handleSortChange('views')"
          >
            浏览量排序
          </span>
        </div>
      </div>

      <!-- 列表区域 -->
      <div class="table-wrapper">
        <a-spin :spinning="loading">
          <div v-if="dataSource && dataSource.length" class="demand-table">
            <div class="list-header">
              <div class="col name">需求名称</div>
              <div class="col area">需求地点</div>
              <div class="col industry">技术领域</div>
              <div class="col publish">发布时间</div>
              <div class="col budget">需求预算</div>
            </div>
            <transition-group name="list-fade" tag="div" class="list-body">
              <div
                class="list-row"
                v-for="(item, index) in dataSource"
                :key="item.id"
                :style="{ '--delay': index * 0.05 + 's' }"
                @click="handleDetail(item)"
              >
                <div class="col name">
                  <div class="name-title">
                    <span class="link-bullet"></span>
                    <div class="title-text">{{ item.name }}</div>
                  </div>
                  <div class="name-sub">{{ item.companyName || '未填写' }}</div>
                </div>
                <div class="col area">
                  <a-icon type="environment" />
                  <span>{{ item.areaText || '未填写' }}</span>
                </div>
                <div class="col industry">
                  <a-icon type="appstore" />
                  <span>{{ item.technicalField_dictText || '未填写' }}<span v-if="item.technicalField_dictText=='其他'">({{ item.technicalFieldCustom}})</span></span>
                </div>
                <div class="col publish">
                  <a-icon type="clock-circle" />
                  <span>{{ formatDate(item.createTime) }}</span>
                </div>
                <div class="col budget">
                  <span class="budget-text">{{ formatBudget(item.budget) }}</span>
                  <a-button
                    type="link"
                    class="detail-btn"
                    @click.stop="handleDetail(item)"
                  >
                    查看详情
                  </a-button>
                </div>
              </div>
            </transition-group>
          </div>
          <a-empty v-else class="empty-holder">
            <span slot="description">暂无相关需求</span>
          </a-empty>
        </a-spin>
        <div class="pagination-wrapper" v-if="ipagination.total">
          <a-pagination
            size="small"
            :current="ipagination.current"
            :pageSize="ipagination.pageSize"
            :total="ipagination.total"
            :showQuickJumper="ipagination.showQuickJumper"
            :showSizeChanger="ipagination.showSizeChanger"
            :pageSizeOptions="ipagination.pageSizeOptions"
            @change="onPageChange"
            @showSizeChange="onPageSizeChange"
          />
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
import { ajaxGetDictItems } from "@/api/api";
import Area from "@/components/_util/Area";

export default {
  name: "DemandList",
  mixins: [JeecgListMixin],
  data() {
    return {
      description: "技术需求列表",
      url: {
        list: "/xjtech/techRequirement/list"
      },
      sortType: "latest", // latest: 最新发布, views: 浏览量
      fieldOptions: [], // 技术领域选项
      cooperateOptions: [], // 合作方式选项
      regionOptions: [], // 地区选项
      pcaData: null, // 省市区工具
      queryParam: {
        reviewStatus: 1
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return (this.ipagination.current - 1) * this.ipagination.pageSize + parseInt(index) + 1;
          }
        },
        {
          title: '需求名称',
          align: 'left',
          dataIndex: 'name',
          width: 250,
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '需求单位',
          align: 'center',
          dataIndex: 'requirementUnit',
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'requirementUnit' }
        },
        {
          title: '技术领域',
          align: 'center',
          dataIndex: 'technicalField_dictText',
          width: 150,
          scopedSlots: { customRender: 'technicalField' }
        },
        {
          title: '合作方式',
          align: 'center',
          dataIndex: 'cooperateWay_dictText',
          width: 120,
        },
        {
          title: '所在地区',
          align: 'center',
          dataIndex: 'areaId_dictText',
          width: 120,
          scopedSlots: { customRender: 'areaId' }
        },
        {
          title: '浏览量',
          align: 'center',
          dataIndex: 'viewCount',
          width: 100,
          sorter: true,
          scopedSlots: { customRender: 'viewCount' }
        },
        {
          title: '发布时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 120,
          sorter: true,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  created() {
    this.pcaData = new Area();
    this.initDictOptions();
  },
  methods: {
    // mixin钩子：初始化列表字典配置
    initDictConfig() {
      // 获取技术领域选项（从分类树获取）
      this.loadFieldOptions();
      // 获取地区选项
      this.loadRegionOptions();
    },
    // 初始化字典选项
    initDictOptions() {
      // 获取合作方式选项
      ajaxGetDictItems("cooperate_way").then((res) => {
        if (res.success) {
          this.cooperateOptions = res.result || [];
        }
      });
      

    },
    // 加载技术领域选项
    loadFieldOptions() {
      getAction("/sys/category/loadTreeData", {
        pcode: "B03"
      }).then((res) => {
        if (res.success && res.result) {
          this.fieldOptions = res.result.map((item) => ({
            value: item.key,
            text: item.title
          }));
        }
      });
    },
    // 获取省市区名称
    getAreaText(code) {
      if (!code || !this.pcaData) {
        return "";
      }
      return this.pcaData.getText(code);
    },
    // 补充展示字段
    decorateListData() {
      if (!Array.isArray(this.dataSource)) {
        return;
      }
      this.dataSource = this.dataSource.map((item) => {
        const areaText = item.areaId_dictText || this.getAreaText(item.areaId);
        return {
          ...item,
          areaText
        };
      });
    },
    // 加载地区选项
    loadRegionOptions() {
      const regions = [
        { value: "110000", text: "北京市" },
        { value: "120000", text: "天津市" },
        { value: "130000", text: "河北省" },
        { value: "140000", text: "山西省" },
        { value: "150000", text: "内蒙古自治区" },
        { value: "210000", text: "辽宁省" },
        { value: "220000", text: "吉林省" },
        { value: "230000", text: "黑龙江省" },
        { value: "310000", text: "上海市" },
        { value: "320000", text: "江苏省" },
        { value: "330000", text: "浙江省" },
        { value: "340000", text: "安徽省" },
        { value: "350000", text: "福建省" },
        { value: "360000", text: "江西省" },
        { value: "370000", text: "山东省" },
        { value: "410000", text: "河南省" },
        { value: "420000", text: "湖北省" },
        { value: "430000", text: "湖南省" },
        { value: "440000", text: "广东省" },
        { value: "450000", text: "广西壮族自治区" },
        { value: "460000", text: "海南省" },
        { value: "500000", text: "重庆市" },
        { value: "510000", text: "四川省" },
        { value: "520000", text: "贵州省" },
        { value: "530000", text: "云南省" },
        { value: "540000", text: "西藏自治区" },
        { value: "610000", text: "陕西省" },
        { value: "620000", text: "甘肃省" },
        { value: "630000", text: "青海省" },
        { value: "640000", text: "宁夏回族自治区" },
        { value: "650000", text: "新疆维吾尔自治区" },
        { value: "660000", text: "新疆生产建设兵团" }
      ];
      this.regionOptions = regions;
    },
    // 筛选标签点击
    handleFilterChange(field, value) {
      this.queryParam[field] = value;
      this.searchQuery();
    },
    // 排序切换
    handleSortChange(type) {
      this.sortType = type;
      if (type === "latest") {
        this.isorter.column = "createTime";
        this.isorter.order = "desc";
      } else if (type === "views") {
        this.isorter.column = "viewCount";
        this.isorter.order = "desc";
      }
      this.searchQuery();
    },
    // 查看详情
    handleDetail(record) {
      this.$router.push({
        path: "/demand/detail",
        query: { id: record.id }
      });
    },
    // 格式化发布时间
    formatDate(value) {
      if (!value) {
        return "--";
      }
      return value.substring(0, 10);
    },
    // 格式化预算
    formatBudget(value) {
      if (value === null || value === undefined || value === "") {
        return "面议";
      }
      const num = Number(value);
      if (!isNaN(num)) {
        if (num >= 10000) {
          return `${(num / 10000).toFixed(num % 10000 === 0 ? 0 : 1)}万`;
        }
        return `${num}元`;
      }
      return value;
    },
    // 分页切换
    onPageChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;
      this.loadData();
    },
    // 每页数量切换
    onPageSizeChange(current, size) {
      this.ipagination.current = 1;
      this.ipagination.pageSize = size;
      this.loadData(1);
    },
    // 列表数据加载完成回调
    loadOk() {
      this.decorateListData();
    }
  }
};
</script>

<style scoped lang="less">
.demand-list-wrapper {
  background: #f0f2f5;
  min-height: 100vh;
  //padding: 12px;
  animation: fadeIn 0.5s ease-in-out;

  .content {
    background: #fff;
    border-radius: 8px;
    padding: 32px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.3s ease;
    
    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
  }
}

// 页面标题
.page-header {
  margin-bottom: 32px;
  text-align: center;
  position: relative;
  padding: 20px 0;

  .page-title {
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 0;

    .title-text {
      font-size: 36px;
      font-weight: 600;
      color: #333;
      position: relative;
      z-index: 2;
      letter-spacing: 2px;
      animation: slideDown 0.6s ease-out;
    }

    .title-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 72px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.03);
      z-index: 1;
      letter-spacing: 8px;
      white-space: nowrap;
      animation: fadeInScale 0.8s ease-out;
    }
  }
}

// 动画定义
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 搜索区域
.search-section {
  margin-bottom: 32px;
  animation: slideInLeft 0.6s ease-out 0.2s both;

  .search-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(4px);
    }

    .search-label {
      width: 80px;
      font-size: 14px;
      color: #333;
      flex-shrink: 0;
      font-weight: 500;
    }

    .search-input {
      flex: 1;
      max-width: 500px;
      margin-right: 12px;
      transition: all 0.3s ease;
      border-radius: 4px;

      &:focus,
      &:hover {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      }

      /deep/ .ant-input {
        transition: all 0.3s ease;
      }
    }

    .search-btn {
      min-width: 48px;
      height: 32px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
      }

      &:active {
        transform: translateY(0);
      }

      /deep/ .anticon {
        font-size: 16px;
      }
    }
  }
}

// 筛选区域
.filter-section {
  margin-bottom: 32px;
  padding: 24px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.3s both;

  .filter-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      width: 100px;
      font-size: 14px;
      color: #333;
      flex-shrink: 0;
      padding-top: 6px;
      font-weight: 500;
    }

    .filter-tags {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .filter-tag {
        margin: 0;
        padding: 6px 16px;
        cursor: pointer;
        border: 1px solid #d9d9d9;
        background: #fff;
        color: #333;
        border-radius: 20px;
        font-size: 14px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          border-radius: 50%;
          background: rgba(24, 144, 255, 0.1);
          transform: translate(-50%, -50%);
          transition: width 0.4s ease, height 0.4s ease;
        }

        &:hover {
          border-color: #1890ff;
          color: #1890ff;
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);

          &::before {
            width: 100px;
            height: 100px;
          }
        }

        &.tag-active {
          background: #1890ff;
          border-color: #1890ff;
          color: #fff;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
          animation: pulse 0.3s ease;

          &:hover {
            background: #40a9ff;
            border-color: #40a9ff;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
          }

          &::before {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
}

// 结果头部
.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 0;
  border-bottom: 2px solid #e8e8e8;
  animation: slideInLeft 0.6s ease-out 0.4s both;

  .result-count {
    font-size: 15px;
    color: #333;
    font-weight: 500;

    .count-number {
      color: #ff6600;
      font-weight: 700;
      font-size: 18px;
      margin: 0 6px;
      animation: countUp 0.6s ease-out;
    }
  }

  .sort-options {
    display: flex;
    gap: 20px;

    .sort-item {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      padding: 6px 16px;
      border-radius: 20px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background: #1890ff;
        transform: translateX(-50%);
        transition: width 0.3s ease;
      }

      &:hover {
        color: #1890ff;
        background: #e6f7ff;
        transform: translateY(-2px);

        &::after {
          width: 60%;
        }
      }

      &.sort-active {
        color: #1890ff;
        background: #e6f7ff;
        font-weight: 600;
        box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);

        &::after {
          width: 80%;
        }
      }
    }
  }
}

@keyframes countUp {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 表格区域
.table-wrapper {
  margin-bottom: 24px;
  animation: slideInLeft 0.6s ease-out 0.5s both;

  .ant-spin-nested-loading {
    width: 100%;
  }

  .demand-table {
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 10px 30px rgba(15, 38, 84, 0.08);
  }

  .list-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    background: linear-gradient(90deg, #f6f9ff 0%, #eef5ff 100%);
    padding: 16px 24px;
    font-size: 14px;
    font-weight: 600;
    color: #51617b;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .list-body {
    display: flex;
    flex-direction: column;
  }

  .list-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 12px;
    padding: 20px 24px;
    border-bottom: 1px solid #f2f2f2;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
    animation: fadeInRow 0.6s ease forwards;
    animation-delay: var(--delay, 0s);

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      transform: translateY(-2px);
      background: linear-gradient(90deg, rgba(64, 169, 255, 0.08), rgba(30, 144, 255, 0.05));
      box-shadow: 0 12px 24px rgba(24, 144, 255, 0.15);
    }
  }

  .col {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #333;
    font-size: 14px;

    .anticon {
      color: #1890ff;
    }
  }

  .col.name {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;

    .name-title {
      display: flex;
      align-items: center;
      gap: 10px;

      .link-bullet {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: linear-gradient(120deg, #1890ff, #40a9ff);
        box-shadow: 0 0 10px rgba(24, 144, 255, 0.4);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .title-text {
        font-size: 16px;
        font-weight: 600;
        color: #1f2d3d;
        transition: color 0.3s ease;
      }
    }

    .name-sub {
      font-size: 13px;
      color: #8c8c8c;
    }

    .list-row:hover & .title-text {
      color: #1890ff;
    }

    .list-row:hover & .link-bullet {
      transform: scale(1.2);
      box-shadow: 0 0 16px rgba(24, 144, 255, 0.6);
    }
  }

  .col.budget {
    justify-content: space-between;

    .budget-text {
      color: #ff5c5c;
      font-weight: 600;
      font-size: 16px;
    }

    .detail-btn {
      padding: 0;
      font-weight: 600;
      color: #1890ff;

      &:hover {
        color: #40a9ff;
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
    animation: fadeIn 0.4s ease;

    /deep/ .ant-pagination-item-active {
      border-color: #1890ff;
    }
  }

  .empty-holder {
    padding: 60px 0;
  }

  .list-fade-enter-active,
  .list-fade-leave-active {
    transition: all 0.4s ease;
  }

  .list-fade-enter,
  .list-fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }
}

@keyframes fadeInRow {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .demand-list-wrapper {
    padding: 8px;

    .content {
      padding: 16px;
    }
  }

  .page-header {
    margin-bottom: 24px;
    padding: 16px 0;

    .page-title {
      .title-text {
        font-size: 28px;
      }

      .title-bg {
        font-size: 48px;
      }
    }
  }

  .search-section {
    margin-bottom: 24px;

    .search-row {
      flex-direction: column;
      align-items: flex-start;

      .search-label {
        margin-bottom: 8px;
      }

      .search-input {
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        margin-bottom: 8px;
      }
    }
  }

  .filter-section {
    padding: 16px;

    .filter-row {
      flex-direction: column;

      .filter-label {
        margin-bottom: 12px;
        width: 100%;
      }
    }
  }

  .result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .table-wrapper {
    overflow: visible;

    .list-header {
      display: none;
    }

    .list-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .col {
      width: 100%;
    }

    .col.budget {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
}
</style>
